import { render, staticRenderFns } from "./BaseListLayout.vue?vue&type=template&id=4757bab0&scoped=true&"
import script from "./BaseListLayout.vue?vue&type=script&lang=js&"
export * from "./BaseListLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseListLayout.vue?vue&type=style&index=0&id=4757bab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4757bab0",
  null
  
)

export default component.exports